import { render, staticRenderFns } from "./ReservationExternalLinks.vue?vue&type=template&id=ff09f004"
import script from "./ReservationExternalLinks.vue?vue&type=script&lang=js"
export * from "./ReservationExternalLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports